import { render, staticRenderFns } from "./MemberSimpleV2.vue?vue&type=template&id=f39b38d0&scoped=true&"
import script from "./MemberSimpleV2.vue?vue&type=script&lang=js&"
export * from "./MemberSimpleV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39b38d0",
  null
  
)

export default component.exports